<template>
  <v-flex
    xs12
    class="px-0 pt-0"
  >
    <v-card class="dash-list-title mb-2">
      <v-card-text class="body-1 text-truncate py-2">
        <slot />
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  props: {
    //
  },
};
</script>

<style>
.theme--dark .dash-list-title {
  background-color: #3a3a3a;
  border-bottom: 1px solid #dedede;
}

.theme--light .dash-list-title {
  background-color: #efefef;
  border-bottom: 1px solid #121212;
}
</style>
